var path = '/opt/atlassian/pipelines/agent/build/src/app/common/components/show-remaining-chars/show-remaining-chars.html';
var html = "<span class=namespan> {{$ctrl.getRemainingCharacters($ctrl.text, $ctrl.maxChars)}} out of {{$ctrl.maxChars}} Characters left</span> ";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


//////////////////
// WEBPACK FOOTER
// ./src/app/common/components/show-remaining-chars/show-remaining-chars.html
// module id = 928
// module chunks = 0